//TODO 샘플 애드배너
import { jsx as _jsx } from "react/jsx-runtime";
import { AdBannerList, useAdBannerQuery } from "../Banner/AdBanner";
import { useBrandStore } from "./BrandProvider";
export const BrandAdBanner = ()=>{
    const name = useBrandStore((state)=>state.brand.name);
    const { adBannerResponse , noAdItems  } = useAdBannerQuery({
        position: "brandHome",
        pageId: name
    });
    if (noAdItems) return null;
    return /*#__PURE__*/ _jsx(AdBannerList, {
        position: "brandHome",
        children: adBannerResponse.items.map((param)=>/*#__PURE__*/ {
            let { link , imageUrl , imageUrlPc , imageUrlTablet , imageUrlMobile , id  } = param;
            return _jsx(AdBannerList.Item, {
                link: link,
                imageUrl: imageUrl,
                imageUrlPc: imageUrlPc,
                imageUrlTablet: imageUrlTablet,
                imageUrlMobile: imageUrlMobile,
                id: id,
                mixpanelPosition: "product detail page"
            }, "adbanner-" + id);
        })
    });
};
